
export namespace FormulationAndRouteEnums
{
    export enum AdministrationRoute {
        UNDEFINED = "undefined",
        INTERMUSCULAR = "intermuscular",
        INTRAVENOUS_BOLUS = "intravenousBolus",
        INTRAVENOUS_DRIP = "intravenousDrip",
        NASAL = "nasal",
        ORAL = "oral",
        RECTAL = "rectal",
        SUBCUTANEOUS = "subcutaneous",
        SUBLINGUAL = "sublingual",
        TRANSDERMAL = "transdermal",
        VAGINAL = "vaginal",
    }

    export enum AbsorptionModelDrug {
        EXTRA = "extra",
        EXTRA_LAG = "extra.lag",
        INFUSION = "infusion",
        BOLUS = "bolus",
    }

    export enum AbsorptionModelComputation {
        UNDEFINED = "undefined",
        INTRAVASCULAR = "intravascular",
        EXTRAVASCULAR = "extravascular",
        EXTRAVASCULAR_LAG = "extravascularLag",
        INFUSION = "infusion",
    }
}

export function absorptionModelDrugToComputation(
    modelIdResponse: FormulationAndRouteEnums.AbsorptionModelDrug
): FormulationAndRouteEnums.AbsorptionModelComputation
{
    switch (modelIdResponse) {
        case FormulationAndRouteEnums.AbsorptionModelDrug.EXTRA:
            return FormulationAndRouteEnums.AbsorptionModelComputation.EXTRAVASCULAR;

        case FormulationAndRouteEnums.AbsorptionModelDrug.EXTRA_LAG:
            return FormulationAndRouteEnums.AbsorptionModelComputation.EXTRAVASCULAR_LAG;

        case FormulationAndRouteEnums.AbsorptionModelDrug.INFUSION:
            return FormulationAndRouteEnums.AbsorptionModelComputation.INFUSION;

        case FormulationAndRouteEnums.AbsorptionModelDrug.BOLUS:
            return FormulationAndRouteEnums.AbsorptionModelComputation.INTRAVASCULAR;
    }
}
